import { React, useState, useEffect, Fragment } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import moment from "moment";
import { Icon } from "@iconify/react";
import "./MessageList.css";
import ModalMedia from "./ModalMedia";
import Loader from "../Components/Loader";
import renderMessage from "../Helper/renderMessage";
import {
  getMessageHistory,
  getMessageList,
  updateAgentRead,
} from "../Store/Actions/IGAction";

function MessageListIG({ chatListID, IGID }) {
  const [getDate, setGetDate] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [isModalMediaOpen, setIsModalMediaOpen] = useState(false);
  const [selectedMediaURL, setSelectedMediaURL] = useState("");
  const { updateChat, updateChatSingle } = useSelector((state) => state.chat);
  let scrollTimer = null;

  useEffect(() => {
    const renderDateFLoat = () => {
      const messageBox = document.getElementById(
        "messageListInfiniteScrollTarget"
      );
      let dateFloat = document.getElementsByClassName("DateFloat");
      if (dateFloat.length > 0) dateFloat = dateFloat[0];
      const scrollEvent = (box) => {
        dateFloat.style.top = "0vh";
        dateFloat.style.opacity = 1;

        clearTimeout(scrollTimer);

        scrollTimer = setTimeout(() => {
          dateFloat.style.top = "-2vh";
          dateFloat.style.opacity = 0;
        }, 2000);

        const dateLabels = document.querySelectorAll(".DateSeparator");
        let currentLabel = null;
        let boxR = box.getBoundingClientRect();

        dateLabels.forEach((dateLabel, idx, arr) => {
          let dlR = dateLabel.getBoundingClientRect();
          if (dlR.top > boxR.top) {
            currentLabel = idx >= dateLabels.length ? arr[idx] : arr[idx + 1];
          } else if (idx === 0) {
            currentLabel = arr[idx];
          }
        });

        if (currentLabel) {
          let el = currentLabel.getElementsByClassName("DateSeparatorVal");
          if (el && el.length > 0) setGetDate(el[0].innerText);
        }
      };

      messageBox?.removeEventListener("scroll", () => {
        scrollEvent(messageBox);
      });

      messageBox?.addEventListener("scroll", () => {
        scrollEvent(messageBox);
      });
    };

    renderDateFLoat();
  }, []);

  // Effect ran when selected chat is changed
  useEffect(() => {
    if (IGID) {
      getMessageHistory(chatListID, IGID)
        .then((response) => {
          if (response.status) {
            process.env.NODE_ENV === "development" &&
              console.log("message history: ", response.data);

            setMessages(response.data);
            setGetDate(response.data[0]?.CreatedTime);
            setIsLoading(false);
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      fetchMessageList(true);
    }
  }, [chatListID]);

  // Effect ran when a new chat comes
  // Doesn't run when used in chat history
  useEffect(() => {
    !IGID && fetchMessageList();
  }, [updateChat, updateChatSingle]);

  const fetchMessageList = (isFirstLoad) => {
    if (isFirstLoad) {
      setIsLoading(true);
    }

    getMessageList(chatListID)
      .then((response) => {
        if (response.status) {
          console.log("message list: ", response.data);
          setMessages(response.data);
          setGetDate(response.data[0].CreatedTime);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });
  };

  const separator = (index, date, otherDate) => {
    if (
      index.toString() === "dateseparator" ||
      index.toString() === "datefloat"
    ) {
      let text = date;
      if (date === moment.utc().format("DD MMM YYYY")) text = "Today";
      else if (date === moment.utc().add(-1, "d").format("DD MMM YYYY"))
        text = "Yesterday";
      return date === otherDate ? (
        ""
      ) : (
        <div
          className={
            index.toString() === "dateseparator" ? "DateSeparator" : "DateFloat"
          }
        >
          <span>{text}</span>
          <span className="DateSeparatorVal" style={{ display: "none" }}>
            {date}
          </span>
        </div>
      );
    }
  };

  const statusSender = (status) => {
    let icon;

    switch (status) {
      case "sent":
      case "NEW":
        icon = "bi:check";
        break;

      case "delivered":
      case "read":
        icon = "bi:check-all";
        break;

      default:
        icon = "mingcute:time-fill";
        break;
    }

    return (
      <span className="message-status">
        {status === "failed" ? (
          "Failed"
        ) : (
          <Icon
            color={status === "read" ? "#0343C7" : "#727272"}
            height="18"
            icon={icon}
          />
        )}
      </span>
    );
  };

  function renderHandoverSeparator(currentMessage, messages, currentIndex) {
    // don't show separator if current message is from customer
    if (currentMessage?.MessageFrom === "CUSTOMER") {
      return null;
    }

    // Find the previous agent message
    let previousAgentMessage = null;

    for (let i = currentIndex + 1; i < messages.length; i++) {
      if (
        messages[i].MessageFrom === "AGENT" ||
        messages[i].MessageFrom === "CHATBOT"
      ) {
        previousAgentMessage = messages[i];
        break;
      }
    }

    // Show chat room ID on start
    if (!previousAgentMessage) {
      return (
        <div className="handover-separator">
          <hr />

          <p>
            ChatRoom #IG{currentMessage.ChatListID} with{" "}
            {currentMessage.AgentName ?? "Operator"}
          </p>

          <hr />
        </div>
      );
    } else if (
      // Show separator if agent changed
      previousAgentMessage?.AgentName !== currentMessage?.AgentName &&
      currentMessage?.Type !== "template"
    ) {
      return (
        <div className="handover-separator">
          <hr />

          <p>
            Handover to {currentMessage.AgentName ?? "Operator"} at{" "}
            {moment.utc(currentMessage.CreatedTime).format("HH:mm")}
          </p>

          <hr />
        </div>
      );
    }

    return null;
  }

  return (
    <div className="message-list">
      <ModalMedia
        mediaURL={selectedMediaURL}
        open={isModalMediaOpen}
        source="IG"
        onClose={() => {
          setSelectedMediaURL("");
          setIsModalMediaOpen(false);
        }}
      />

      {isLoading ? (
        <Loader />
      ) : messages.length ? (
        <div className="message-list-content">
          {separator(
            "datefloat",
            moment.utc(getDate).format("DD MMM YYYY"),
            moment.utc(getDate).add(1, "d").format("DD MMM YYYY")
          )}

          <div
            className="infinite-scroll-target"
            id="messageListInfiniteScrollTarget"
          >
            <InfiniteScroll
              dataLength={messages.length}
              style={{ display: "flex", flexDirection: "column-reverse" }}
              inverse
              scrollableTarget="messageListInfiniteScrollTarget"
              scrollThreshold={0.95}
            >
              {/* Reverse list */}
              {messages?.toReversed().map((message, index, array) => {
                // Read message action
                if (
                  message.MessageFrom === "CUSTOMER" &&
                  !message.IsReadByAgent
                ) {
                  updateAgentRead({ igmid: message.IGMID })
                    .then((response) => {
                      if (response.status) {
                      } else {
                        console.log(
                          "Error read message ",
                          message.IGMID,
                          ": ",
                          response.error
                        );
                      }
                    })
                    .catch((err) => {
                      console.log(
                        "Error read message ",
                        message.IGMID,
                        ": ",
                        err
                      );
                    });
                }

                return (
                  <Fragment key={message.MessageID}>
                    <div>
                      <div
                        className={`message-bubble-container
                          ${
                            message.MessageFrom === "AGENT"
                              ? "agent"
                              : "customer"
                          }
                        `}
                      >
                        <div
                          className={`message-bubble ${
                            message.MessageFrom === "CUSTOMER" &&
                            message.Status === "deleted"
                              ? "deleted"
                              : ""
                          }`}
                        >
                          {message.MessageFrom === "AGENT" && (
                            <span className="sender-name">
                              {message.AgentName}
                            </span>
                          )}

                          {
                            // For Instagram story reply
                            message.MessageFrom === "CUSTOMER" &&
                              message.Type === "story_reply" && (
                                <span className="instagram-story">
                                  Replied to your story
                                </span>
                              )
                          }

                          {renderMessage(
                            message.MessageFrom === "CUSTOMER" &&
                              message.Status === "deleted"
                              ? `"${message.BodyText}"\nRemoved by Customer`
                              : message.BodyText,

                            message.Type,
                            message.StoryURL,
                            message.TemplateName,
                            setIsModalMediaOpen,
                            setSelectedMediaURL
                          )}

                          {
                            // For Instagram story mention
                            message.MessageFrom === "CUSTOMER" &&
                              message.Type === "story_mention" && (
                                <span className="instagram-story">
                                  Mentioned you in their story
                                </span>
                              )
                          }

                          <div className="message-info">
                            <div className="message-time">
                              <p>
                                {message.MessageFrom === "CUSTOMER" &&
                                  message.Status === "deleted" &&
                                  "@"}

                                {moment
                                  .utc(message.CreatedTime)
                                  .format("HH:mm")}
                              </p>

                              {message.MessageFrom === "CUSTOMER" &&
                                message.Status === "deleted" && (
                                  <p>
                                    <Icon
                                      height="14"
                                      icon="material-symbols:delete-outline-rounded"
                                    />

                                    {moment
                                      .utc(message.StatusTime)
                                      .format("HH:mm")}
                                  </p>
                                )}
                            </div>

                            {message.MessageFrom === "AGENT"
                              ? statusSender(message.Status)
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>

                    {renderHandoverSeparator(message, array, index)}

                    {separator(
                      "dateseparator",
                      moment.utc(message.CreatedTime).format("DD MMM YYYY"),
                      index >= messages.length - 1
                        ? moment
                            .utc(message.CreatedTime)
                            .add(-1, "d")
                            .format("DD MMM YYYY")
                        : moment
                            .utc(array[index + 1].CreatedTime)
                            .format("DD MMM YYYY")
                    )}
                  </Fragment>
                );
              })}
            </InfiniteScroll>
          </div>
        </div>
      ) : (
        <p className="empty">No chat history found.</p>
      )}
    </div>
  );
}

export default MessageListIG;
